import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TRACE_STATE_HEADER } from '@opentelemetry/core';

import { ConfigurationService, setHeader } from '@mobi/rwc-utils-common-ng-jslib';

/**
 * Only requests to api gateway or IDP CIP should have trace headers. Some examples:
 *  - 'http://localhost:8080/', (for local development)
 *  - 'https://sec-api-b2.app.mobiliar.ch/xxx',
 *  - 'https://api-onprem.app.mobiliar-preprod.ch/xx',
 *  - 'https://api.app.mobiliar-sit.ch/xx',
 *  - 'https://idp.cip.mobiliar-sit.ch/xx',
 *  - '/aro/schreibtisch', 'vvn/profil' (relative url in case this interceptor is before ApiGatewayRoutingInterceptor)
 *
 * All other requests (like to maps.google.com, login.microsoftonline.com) should not have trace headers because of CORS.
 */
export const TRACE_REQUEST_WHITELIST_REGEX =
    // eslint-disable-next-line sonarjs/regex-complexity
    /^https?:\/\/localhost:\d+\/|^https:\/\/(.+\.app|idp\.cip)\.mobiliar(-\w+)?\.ch\/|^(?!https?:\/\/).*/;

/**
 * This interceptor is to add the w3c tracestate http header with the tkId.
 * The tracing lib should be able to set it but didn't find a way to do it. If fixed, this interceptor should be removed.
 */
export function traceStateInterceptor(): HttpInterceptorFn {
    return (req, next) => {
        const headerValue = 'tk-id=' + inject(ConfigurationService).getTkNameId();
        if (req.url.match(TRACE_REQUEST_WHITELIST_REGEX)) {
            req = setHeader(req, TRACE_STATE_HEADER, headerValue);
        }
        return next(req);
    };
}
